import { DemoResultData, DiagnosticReport } from "src/app/Elearning-Models";

export class MockDemoResults{
    public marketingReport: DemoResultData = {
       UnitTestsAvailable: false,
       StudentConsumerCurriculumID: 1,
       StudentName: "Bob Villa",
       IsStudent: true,
       CurriculumName: "Grade 3 Math",
       LessonsIdentified: 5,
       StandardsIdentified: 7,

       TotalLessons: 50,
       TotalStandards: 43,

       MissedLessons: 40,
       FullPrice: 5000,
       BasicPrice: 1000,
    };

       public demoReport: DiagnosticReport = {
         "CourseName":"Consumer Ascend Grade 4 Math",
         TotalLessons: 50,
         AOELessonCount: 0,
         AOILessonCount: 15,
         "NonProficientStandardLessons":[
            {
               "LessonName":"Elapsed Time",
               "Standards":[
                  {
                     "StandardCode":"4.MD.A.2",
                     "StandardDescription":"Use the four operations to solve word problems involving distances, intervals of time, liquid volumes, masses of objects, and money, including problems involving simple fractions or decimals, and problems that require expressing measurements given in a larger unit in terms of a smaller unit. Represent measurement quantities using diagrams such as number line diagrams that feature a measurement scale.",
                     "Proficient":false
                  }
               ]
            },
            {
               "LessonName":"Elapsed Time Using Calendars",
               "Standards":[
                  {
                     "StandardCode":"4.MD.A.2",
                     "StandardDescription":"Use the four operations to solve word problems involving distances, intervals of time, liquid volumes, masses of objects, and money, including problems involving simple fractions or decimals, and problems that require expressing measurements given in a larger unit in terms of a smaller unit. Represent measurement quantities using diagrams such as number line diagrams that feature a measurement scale.",
                     "Proficient":false
                  }
               ]
            },
            {
               "LessonName":"Extending Number Patterns",
               "Standards":[
                  {
                     "StandardCode":"4.OA.C.5",
                     "StandardDescription":"Generate a number or shape pattern that follows a given rule. Identify apparent features of the pattern that were not explicit in the rule itself.",
                     "Proficient":false
                  }
               ]
            },
            {
               "LessonName":"Number Pattern Rules",
               "Standards":[
                  {
                     "StandardCode":"4.OA.C.5",
                     "StandardDescription":"Generate a number or shape pattern that follows a given rule. Identify apparent features of the pattern that were not explicit in the rule itself.",
                     "Proficient":false
                  }
               ]
            },
            {
               "LessonName":"Equivalent Units of Length",
               "Standards":[
                  {
                     "StandardCode":"4.MD.A.2",
                     "StandardDescription":"Use the four operations to solve word problems involving distances, intervals of time, liquid volumes, masses of objects, and money, including problems involving simple fractions or decimals, and problems that require expressing measurements given in a larger unit in terms of a smaller unit. Represent measurement quantities using diagrams such as number line diagrams that feature a measurement scale.",
                     "Proficient":false
                  }
               ]
            },
            {
               "LessonName":"Solving Word Problems with Money",
               "Standards":[
                  {
                     "StandardCode":"4.MD.A.2",
                     "StandardDescription":"Use the four operations to solve word problems involving distances, intervals of time, liquid volumes, masses of objects, and money, including problems involving simple fractions or decimals, and problems that require expressing measurements given in a larger unit in terms of a smaller unit. Represent measurement quantities using diagrams such as number line diagrams that feature a measurement scale.",
                     "Proficient":false
                  }
               ]
            },
            {
               "LessonName":"Estimation and Rounding",
               "Standards":[
                  {
                     "StandardCode":"4.OA.A.3",
                     "StandardDescription":"Solve multistep word problems posed with whole numbers and having whole-number answers using the four operations, including problems in which remainders must be interpreted. Represent these problems using equations with a letter standing for the unknown quantity. Assess the reasonableness of answers using mental computation and estimation strategies including rounding.",
                     "Proficient":false
                  }
               ]
            },
            {
               "LessonName":"Multi-Step Division Word Problem",
               "Standards":[
                  {
                     "StandardCode":"4.OA.A.3",
                     "StandardDescription":"Solve multistep word problems posed with whole numbers and having whole-number answers using the four operations, including problems in which remainders must be interpreted. Represent these problems using equations with a letter standing for the unknown quantity. Assess the reasonableness of answers using mental computation and estimation strategies including rounding.",
                     "Proficient":false
                  }
               ]
            },
            {
               "LessonName":"Multi-Step Division Word Problem",
               "Standards":[
                  {
                     "StandardCode":"4.OA.A.3",
                     "StandardDescription":"Solve multistep word problems posed with whole numbers and having whole-number answers using the four operations, including problems in which remainders must be interpreted. Represent these problems using equations with a letter standing for the unknown quantity. Assess the reasonableness of answers using mental computation and estimation strategies including rounding.",
                     "Proficient":false
                  }
               ]
            },
            {
               "LessonName":"Multi-Step Multiplication Word Problems",
               "Standards":[
                  {
                     "StandardCode":"4.OA.A.3",
                     "StandardDescription":"Solve multistep word problems posed with whole numbers and having whole-number answers using the four operations, including problems in which remainders must be interpreted. Represent these problems using equations with a letter standing for the unknown quantity. Assess the reasonableness of answers using mental computation and estimation strategies including rounding.",
                     "Proficient":false
                  }
               ]
            },
            {
               "LessonName":"Multi-Step Multiplication Word Problems",
               "Standards":[
                  {
                     "StandardCode":"4.OA.A.3",
                     "StandardDescription":"Solve multistep word problems posed with whole numbers and having whole-number answers using the four operations, including problems in which remainders must be interpreted. Represent these problems using equations with a letter standing for the unknown quantity. Assess the reasonableness of answers using mental computation and estimation strategies including rounding.",
                     "Proficient":false
                  }
               ]
            },
            {
               "LessonName":"Understanding Word Problems",
               "Standards":[
                  {
                     "StandardCode":"4.OA.A.3",
                     "StandardDescription":"Solve multistep word problems posed with whole numbers and having whole-number answers using the four operations, including problems in which remainders must be interpreted. Represent these problems using equations with a letter standing for the unknown quantity. Assess the reasonableness of answers using mental computation and estimation strategies including rounding.",
                     "Proficient":false
                  }
               ]
            },
            {
               "LessonName":"Shape and Number Patterns",
               "Standards":[
                  {
                     "StandardCode":"4.OA.C.5",
                     "StandardDescription":"Generate a number or shape pattern that follows a given rule. Identify apparent features of the pattern that were not explicit in the rule itself.",
                     "Proficient":false
                  }
               ]
            },
            {
               "LessonName":"Add and Subtract Multi-Digit Whole Numbers",
               "Standards":[
                  {
                     "StandardCode":"4.NBT.B.4",
                     "StandardDescription":"Fluently add and subtract multi-digit whole numbers using the standard algorithm.",
                     "Proficient":false
                  }
               ]
            },
            {
               "LessonName":"Interpret a Multiplication Equation",
               "Standards":[
                  {
                     "StandardCode":"4.OA.A.1",
                     "StandardDescription":"Interpret a multiplication equation as a comparison, e.g., interpret 35 = 5 × 7 as a statement that 35 is 5 times as many as 7 and 7 times as many as 5. Represent verbal statements of multiplicative comparisons as multiplication equations.",
                     "Proficient":false
                  }
               ]
            },
            {
               "LessonName":"Writing Algebraic Expressions",
               "Standards":[
                  {
                     "StandardCode":"4.OA.A.1",
                     "StandardDescription":"Interpret a multiplication equation as a comparison, e.g., interpret 35 = 5 × 7 as a statement that 35 is 5 times as many as 7 and 7 times as many as 5. Represent verbal statements of multiplicative comparisons as multiplication equations.",
                     "Proficient":false
                  }
               ]
            },
            {
               "LessonName":"Base Ten Number System",
               "Standards":[
                  {
                     "StandardCode":"4.NBT.A.1",
                     "StandardDescription":"Recognize that in a multi-digit whole number, a digit in one place represents ten times what it represents in the place to its right.",
                     "Proficient":false
                  }
               ]
            },
            {
               "LessonName":"Multiplying and Dividing Multiples of 10 and 100",
               "Standards":[
                  {
                     "StandardCode":"4.NBT.A.1",
                     "StandardDescription":"Recognize that in a multi-digit whole number, a digit in one place represents ten times what it represents in the place to its right.",
                     "Proficient":false
                  }
               ]
            },
            {
               "LessonName":"Addition and Subtraction",
               "Standards":[
                  {
                     "StandardCode":"4.NBT.B.4",
                     "StandardDescription":"Fluently add and subtract multi-digit whole numbers using the standard algorithm.",
                     "Proficient":false
                  }
               ]
            },
            {
               "LessonName":"Capacity: Tools and Units",
               "Standards":[
                  {
                     "StandardCode":"4.MD.A.1",
                     "StandardDescription":"Know relative sizes of measurement units within one system of units including km, m, cm; kg, g; lb, oz.; l, ml; hr, min, sec. Within a single system of measurement, express measurements in a larger unit in terms of a smaller unit. Record measurement equivalents in a two column table.",
                     "Proficient":false
                  }
               ]
            },
            {
               "LessonName":"Conversions Within Measurement Systems",
               "Standards":[
                  {
                     "StandardCode":"4.MD.A.1",
                     "StandardDescription":"Know relative sizes of measurement units within one system of units including km, m, cm; kg, g; lb, oz.; l, ml; hr, min, sec. Within a single system of measurement, express measurements in a larger unit in terms of a smaller unit. Record measurement equivalents in a two column table.",
                     "Proficient":false
                  }
               ]
            },
            {
               "LessonName":"Conversions Within Measurements Systems",
               "Standards":[
                  {
                     "StandardCode":"4.MD.A.1",
                     "StandardDescription":"Know relative sizes of measurement units within one system of units including km, m, cm; kg, g; lb, oz.; l, ml; hr, min, sec. Within a single system of measurement, express measurements in a larger unit in terms of a smaller unit. Record measurement equivalents in a two column table.",
                     "Proficient":false
                  }
               ]
            },
            {
               "LessonName":"Converting Units",
               "Standards":[
                  {
                     "StandardCode":"4.MD.A.1",
                     "StandardDescription":"Know relative sizes of measurement units within one system of units including km, m, cm; kg, g; lb, oz.; l, ml; hr, min, sec. Within a single system of measurement, express measurements in a larger unit in terms of a smaller unit. Record measurement equivalents in a two column table.",
                     "Proficient":false
                  }
               ]
            },
            {
               "LessonName":"Addition and Subtraction With Angles",
               "Standards":[
                  {
                     "StandardCode":"4.MD.C.7",
                     "StandardDescription":"Recognize angle measure as additive. When an angle is decomposed into non-overlapping parts, the angle measure of the whole is the sum of the angle measures of the parts. Solve addition and subtraction problems to find unknown angles on a diagram in real world and mathematical problems, e.g., by using an equation with a symbol for the unknown angle measure.",
                     "Proficient":false
                  }
               ]
            },
            {
               "LessonName":"Angle Addition ",
               "Standards":[
                  {
                     "StandardCode":"4.MD.C.7",
                     "StandardDescription":"Recognize angle measure as additive. When an angle is decomposed into non-overlapping parts, the angle measure of the whole is the sum of the angle measures of the parts. Solve addition and subtraction problems to find unknown angles on a diagram in real world and mathematical problems, e.g., by using an equation with a symbol for the unknown angle measure.",
                     "Proficient":false
                  }
               ]
            },
            {
               "LessonName":"Factors and Multiples",
               "Standards":[
                  {
                     "StandardCode":"4.OA.B.4",
                     "StandardDescription":"Find all factor pairs for a whole number in the range 1—100. Recognize that a whole number is a multiple of each of its factors. Determine whether a given whole number in the range 1—100 is a multiple of a given one-digit number. Determine whether a given whole number in the range 1—100 is prime or composite.",
                     "Proficient":false
                  }
               ]
            },
            {
               "LessonName":"Identifying Factors",
               "Standards":[
                  {
                     "StandardCode":"4.OA.B.4",
                     "StandardDescription":"Find all factor pairs for a whole number in the range 1—100. Recognize that a whole number is a multiple of each of its factors. Determine whether a given whole number in the range 1—100 is a multiple of a given one-digit number. Determine whether a given whole number in the range 1—100 is prime or composite.",
                     "Proficient":false
                  }
               ]
            },
            {
               "LessonName":"Multiples, Factors, and Rules for Divisibility",
               "Standards":[
                  {
                     "StandardCode":"4.OA.B.4",
                     "StandardDescription":"Find all factor pairs for a whole number in the range 1—100. Recognize that a whole number is a multiple of each of its factors. Determine whether a given whole number in the range 1—100 is a multiple of a given one-digit number. Determine whether a given whole number in the range 1—100 is prime or composite.",
                     "Proficient":false
                  }
               ]
            },
            {
               "LessonName":"Multiples, Factors, and Rules of Divisibility",
               "Standards":[
                  {
                     "StandardCode":"4.OA.B.4",
                     "StandardDescription":"Find all factor pairs for a whole number in the range 1—100. Recognize that a whole number is a multiple of each of its factors. Determine whether a given whole number in the range 1—100 is a multiple of a given one-digit number. Determine whether a given whole number in the range 1—100 is prime or composite.",
                     "Proficient":false
                  }
               ]
            },
            {
               "LessonName":"Prime and Composite Numbers",
               "Standards":[
                  {
                     "StandardCode":"4.OA.B.4",
                     "StandardDescription":"Find all factor pairs for a whole number in the range 1—100. Recognize that a whole number is a multiple of each of its factors. Determine whether a given whole number in the range 1—100 is a multiple of a given one-digit number. Determine whether a given whole number in the range 1—100 is prime or composite.",
                     "Proficient":false
                  }
               ]
            },
            {
               "LessonName":"Prime and Composite Numbers",
               "Standards":[
                  {
                     "StandardCode":"4.OA.B.4",
                     "StandardDescription":"Find all factor pairs for a whole number in the range 1—100. Recognize that a whole number is a multiple of each of its factors. Determine whether a given whole number in the range 1—100 is a multiple of a given one-digit number. Determine whether a given whole number in the range 1—100 is prime or composite.",
                     "Proficient":false
                  }
               ]
            },
            {
               "LessonName":"Multi-Digit Multiplication",
               "Standards":[
                  {
                     "StandardCode":"4.NBT.B.5",
                     "StandardDescription":"Multiply a whole number of up to four digits by a one-digit whole number, and multiply two two-digit numbers, using strategies based on place value and the properties of operations. Illustrate and explain the calculation by using equations, rectangular arrays, and/or area models.",
                     "Proficient":false
                  }
               ]
            },
            {
               "LessonName":"Multiplying by Tens, Hundreds, and Thousands",
               "Standards":[
                  {
                     "StandardCode":"4.NBT.B.5",
                     "StandardDescription":"Multiply a whole number of up to four digits by a one-digit whole number, and multiply two two-digit numbers, using strategies based on place value and the properties of operations. Illustrate and explain the calculation by using equations, rectangular arrays, and/or area models.",
                     "Proficient":false
                  }
               ]
            },
            {
               "LessonName":"Multiplying Multi-Digit",
               "Standards":[
                  {
                     "StandardCode":"4.NBT.B.5",
                     "StandardDescription":"Multiply a whole number of up to four digits by a one-digit whole number, and multiply two two-digit numbers, using strategies based on place value and the properties of operations. Illustrate and explain the calculation by using equations, rectangular arrays, and/or area models.",
                     "Proficient":false
                  }
               ]
            },
            {
               "LessonName":"Customary Units of Capacity",
               "Standards":[
                  {
                     "StandardCode":"4.MD.A.1",
                     "StandardDescription":"Know relative sizes of measurement units within one system of units including km, m, cm; kg, g; lb, oz.; l, ml; hr, min, sec. Within a single system of measurement, express measurements in a larger unit in terms of a smaller unit. Record measurement equivalents in a two column table.",
                     "Proficient":false
                  }
               ]
            },
            {
               "LessonName":"Customary Units of Capacity",
               "Standards":[
                  {
                     "StandardCode":"4.MD.A.1",
                     "StandardDescription":"Know relative sizes of measurement units within one system of units including km, m, cm; kg, g; lb, oz.; l, ml; hr, min, sec. Within a single system of measurement, express measurements in a larger unit in terms of a smaller unit. Record measurement equivalents in a two column table.",
                     "Proficient":false
                  }
               ]
            },
            {
               "LessonName":"Measures and Degrees of Accuracy",
               "Standards":[
                  {
                     "StandardCode":"4.MD.A.1",
                     "StandardDescription":"Know relative sizes of measurement units within one system of units including km, m, cm; kg, g; lb, oz.; l, ml; hr, min, sec. Within a single system of measurement, express measurements in a larger unit in terms of a smaller unit. Record measurement equivalents in a two column table.",
                     "Proficient":false
                  }
               ]
            },
            {
               "LessonName":"Measuring Capacity",
               "Standards":[
                  {
                     "StandardCode":"4.MD.A.1",
                     "StandardDescription":"Know relative sizes of measurement units within one system of units including km, m, cm; kg, g; lb, oz.; l, ml; hr, min, sec. Within a single system of measurement, express measurements in a larger unit in terms of a smaller unit. Record measurement equivalents in a two column table.",
                     "Proficient":false
                  }
               ]
            },
            {
               "LessonName":"Measuring For Accuracy",
               "Standards":[
                  {
                     "StandardCode":"4.MD.A.1",
                     "StandardDescription":"Know relative sizes of measurement units within one system of units including km, m, cm; kg, g; lb, oz.; l, ml; hr, min, sec. Within a single system of measurement, express measurements in a larger unit in terms of a smaller unit. Record measurement equivalents in a two column table.",
                     "Proficient":false
                  }
               ]
            },
            {
               "LessonName":"Metric and Customary Units and Tools",
               "Standards":[
                  {
                     "StandardCode":"4.MD.A.1",
                     "StandardDescription":"Know relative sizes of measurement units within one system of units including km, m, cm; kg, g; lb, oz.; l, ml; hr, min, sec. Within a single system of measurement, express measurements in a larger unit in terms of a smaller unit. Record measurement equivalents in a two column table.",
                     "Proficient":false
                  }
               ]
            },
            {
               "LessonName":"Metric Units of Capacity",
               "Standards":[
                  {
                     "StandardCode":"4.MD.A.1",
                     "StandardDescription":"Know relative sizes of measurement units within one system of units including km, m, cm; kg, g; lb, oz.; l, ml; hr, min, sec. Within a single system of measurement, express measurements in a larger unit in terms of a smaller unit. Record measurement equivalents in a two column table.",
                     "Proficient":false
                  }
               ]
            },
            {
               "LessonName":"Metric Units of Capacity",
               "Standards":[
                  {
                     "StandardCode":"4.MD.A.1",
                     "StandardDescription":"Know relative sizes of measurement units within one system of units including km, m, cm; kg, g; lb, oz.; l, ml; hr, min, sec. Within a single system of measurement, express measurements in a larger unit in terms of a smaller unit. Record measurement equivalents in a two column table.",
                     "Proficient":false
                  }
               ]
            },
            {
               "LessonName":"Units of Length",
               "Standards":[
                  {
                     "StandardCode":"4.MD.A.1",
                     "StandardDescription":"Know relative sizes of measurement units within one system of units including km, m, cm; kg, g; lb, oz.; l, ml; hr, min, sec. Within a single system of measurement, express measurements in a larger unit in terms of a smaller unit. Record measurement equivalents in a two column table.",
                     "Proficient":false
                  }
               ]
            },
            {
               "LessonName":"Classifying Triangles",
               "Standards":[
                  {
                     "StandardCode":"4.G.A.2",
                     "StandardDescription":"Classify two-dimensional figures based on the presence or absence of parallel or perpendicular lines, or the presence or absence of angles of a specified size. Recognize right triangles as a category, and identify right triangles.",
                     "Proficient":false
                  }
               ]
            },
            {
               "LessonName":"Identifying Polygons",
               "Standards":[
                  {
                     "StandardCode":"4.G.A.2",
                     "StandardDescription":"Classify two-dimensional figures based on the presence or absence of parallel or perpendicular lines, or the presence or absence of angles of a specified size. Recognize right triangles as a category, and identify right triangles.",
                     "Proficient":false
                  }
               ]
            },
            {
               "LessonName":"Naming Shapes",
               "Standards":[
                  {
                     "StandardCode":"4.G.A.2",
                     "StandardDescription":"Classify two-dimensional figures based on the presence or absence of parallel or perpendicular lines, or the presence or absence of angles of a specified size. Recognize right triangles as a category, and identify right triangles.",
                     "Proficient":false
                  }
               ]
            },
            {
               "LessonName":"Two-Dimensional Shapes",
               "Standards":[
                  {
                     "StandardCode":"4.G.A.2",
                     "StandardDescription":"Classify two-dimensional figures based on the presence or absence of parallel or perpendicular lines, or the presence or absence of angles of a specified size. Recognize right triangles as a category, and identify right triangles.",
                     "Proficient":false
                  }
               ]
            },
            {
               "LessonName":"Congruent Figures",
               "Standards":[
                  {
                     "StandardCode":"4.G.A.3",
                     "StandardDescription":"Recognize a line of symmetry for a two-dimensional figure as a line across the figure such that the figure can be folded along the line into matching parts. Identify line-symmetric figures and draw lines of symmetry.",
                     "Proficient":false
                  }
               ]
            },
            {
               "LessonName":"Finding Lines of Symmetry",
               "Standards":[
                  {
                     "StandardCode":"4.G.A.3",
                     "StandardDescription":"Recognize a line of symmetry for a two-dimensional figure as a line across the figure such that the figure can be folded along the line into matching parts. Identify line-symmetric figures and draw lines of symmetry.",
                     "Proficient":false
                  }
               ]
            },
            {
               "LessonName":"84665 - Lines of Symmetry",
               "Standards":[
                  {
                     "StandardCode":"4.G.A.3",
                     "StandardDescription":"Recognize a line of symmetry for a two-dimensional figure as a line across the figure such that the figure can be folded along the line into matching parts. Identify line-symmetric figures and draw lines of symmetry.",
                     "Proficient":false
                  }
               ]
            },
            {
               "LessonName":"81907 - Lines of Symmetry",
               "Standards":[
                  {
                     "StandardCode":"4.G.A.3",
                     "StandardDescription":"Recognize a line of symmetry for a two-dimensional figure as a line across the figure such that the figure can be folded along the line into matching parts. Identify line-symmetric figures and draw lines of symmetry.",
                     "Proficient":false
                  }
               ]
            },
            {
               "LessonName":"101586 - Comparing and Ordering Fractions",
               "Standards":[
                  {
                     "StandardCode":"4.NF.A.2",
                     "StandardDescription":"Compare two fractions with different numerators and different denominators, e.g., by creating common denominators or numerators, or by comparing to a benchmark fraction such as 1/2. Recognize that comparisons are valid only when the two fractions refer to the same whole. Record the results of comparisons with symbols >, =, or <, and justify the conclusions, e.g., by using a visual fraction model.",
                     "Proficient":false
                  }
               ]
            },
            {
               "LessonName":"82088 - Comparing Fractions",
               "Standards":[
                  {
                     "StandardCode":"4.NF.A.2",
                     "StandardDescription":"Compare two fractions with different numerators and different denominators, e.g., by creating common denominators or numerators, or by comparing to a benchmark fraction such as 1/2. Recognize that comparisons are valid only when the two fractions refer to the same whole. Record the results of comparisons with symbols >, =, or <, and justify the conclusions, e.g., by using a visual fraction model.",
                     "Proficient":false
                  }
               ]
            },
            {
               "LessonName":"101587 - Comparing Fractions",
               "Standards":[
                  {
                     "StandardCode":"4.NF.A.2",
                     "StandardDescription":"Compare two fractions with different numerators and different denominators, e.g., by creating common denominators or numerators, or by comparing to a benchmark fraction such as 1/2. Recognize that comparisons are valid only when the two fractions refer to the same whole. Record the results of comparisons with symbols >, =, or <, and justify the conclusions, e.g., by using a visual fraction model.",
                     "Proficient":false
                  }
               ]
            }
         ],
         "StandardsNotTestedLessons":[
            {
               "LessonName":"Elapsed Time",
               "Standards":[
                  {
                     "StandardCode":"4.MD.A.2",
                     "StandardDescription":"Use the four operations to solve word problems involving distances, intervals of time, liquid volumes, masses of objects, and money, including problems involving simple fractions or decimals, and problems that require expressing measurements given in a larger unit in terms of a smaller unit. Represent measurement quantities using diagrams such as number line diagrams that feature a measurement scale.",
                     "Proficient":false
                  }
               ]
            },
            {
               "LessonName":"Elapsed Time Using Calendars",
               "Standards":[
                  {
                     "StandardCode":"4.MD.A.2",
                     "StandardDescription":"Use the four operations to solve word problems involving distances, intervals of time, liquid volumes, masses of objects, and money, including problems involving simple fractions or decimals, and problems that require expressing measurements given in a larger unit in terms of a smaller unit. Represent measurement quantities using diagrams such as number line diagrams that feature a measurement scale.",
                     "Proficient":false
                  }
               ]
            }],
         "ProficientStandards":[
            {
               "StandardCode":"4.NBT.B.6",
               "StandardDescription":"Find whole-number quotients and remainders with up to four-digit dividends and one-digit divisors, using strategies based on place value, the properties of operations, and/or the relationship between multiplication and division. Illustrate and explain the calculation by using equations, rectangular arrays, and/or area models.",
               "Proficient":true
            },
            {
               "StandardCode":"4.NF.B.4a",
               "StandardDescription":"Understand a fraction a/b as a multiple of 1/b.",
               "Proficient":true
            }
         ]
      };
}